<!-- Add hidden file inputs for each template type -->
<input #consultantFileInput type="file" style="display: none;" accept=".html,.docx"
    (change)="onFileSelected($event, 'consultantTemplate')">
<input #representativeFileInput type="file" style="display: none;" accept=".html,.docx"
    (change)="onFileSelected($event, 'representativeTemplate')">
<input #counterFileInput type="file" style="display: none;" accept=".html,.docx"
    (change)="onFileSelected($event, 'counterTemplate')">
<input #partnerFileInput type="file" style="display: none;" accept=".html,.docx"
    (change)="onFileSelected($event, 'partnerTemplate')">
<input #unitFileInput type="file" style="display: none;" accept=".html,.docx"
    (change)="onFileSelected($event, 'unitTemplate')">

<div class="dialog-container">
    <div class="dialog-header">
        <h1 mat-dialog-title>Templates de Contrato</h1>
        <p class="subtitle">Configure templates para cada tipo de parceiro</p>
    </div>

    <form [formGroup]="form">
        <mat-dialog-content>
            <!-- Indicador de carregamento -->
            <div *ngIf="loading" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Carregando templates...</p>
            </div>

            <div *ngIf="!loading" class="template-management">
                <!-- Cabeçalho com informações -->
                <div class="template-management-header">
                    <div class="info-section">
                        <mat-icon color="primary">info</mat-icon>
                        <div class="info-text">
                            <p>Os templates são usados para gerar contratos
                                automáticos baseados no tipo do parceiro.</p>
                            <p>Selecione um tipo de parceiro e configure seu
                                modelo de contrato.</p>
                        </div>
                    </div>
                </div>

                <!-- Navegação entre tipos de templates (estilo abas) -->
                <div class="template-tabs-container">
                    <div class="template-tabs">
                        <div class="template-tab" *ngFor="let category of templateCategories"
                            [class.active]="isTemplateTypeActive(category.type)"
                            (click)="changeTemplateType(category.type)">
                            <mat-icon>{{category.icon}}</mat-icon>
                            <span>{{category.title}}</span>
                        </div>
                    </div>
                </div>

                <!-- Template ativo -->
                <div class="active-template">
                    <ng-container *ngFor="let category of templateCategories">
                        <mat-card class="template-card" *ngIf="isTemplateTypeActive(category.type)">
                            <mat-card-header class="template-card-header">
                                <mat-icon mat-card-avatar>{{category.icon}}</mat-icon>
                                <mat-card-title>{{category.title}}</mat-card-title>
                                <mat-card-subtitle>{{category.description}}</mat-card-subtitle>
                                <span fxFlex></span> <!-- Spacer -->
                                <!-- Status movido para o header do card -->
                                <div *ngIf="selectedFiles[category.formControlName]"
                                    class="pending-file-indicator header-indicator">
                                    <mat-icon color="warn">warning</mat-icon>
                                    <span>Arquivo pendente: {{ selectedFiles[category.formControlName]?.name }}</span>
                                </div>
                                <div class="template-status header-status"
                                    *ngIf="hasTemplate(category.formControlName) && !selectedFiles[category.formControlName]">
                                    <mat-icon color="primary">check_circle</mat-icon>
                                    <span>Configurado</span>
                                </div>
                            </mat-card-header>

                            <mat-card-content class="template-card-content">
                                <div class="template-actions">
                                    <!-- Ações (Importar, Visualizar, Baixar) -->
                                    <button mat-stroked-button color="accent" [matMenuTriggerFor]="uploadMenu">
                                        <mat-icon>upload_file</mat-icon>
                                        Carregar Arquivo
                                    </button>
                                    <mat-menu #uploadMenu="matMenu">
                                        <button mat-menu-item
                                            (click)="triggerFileInput(category.formControlName, 'html')">
                                            <mat-icon>html</mat-icon>
                                            Carregar HTML
                                        </button>
                                        <button mat-menu-item
                                            (click)="triggerFileInput(category.formControlName, 'docx')">
                                            <mat-icon>description</mat-icon>
                                            Carregar DOCX
                                        </button>
                                    </mat-menu>

                                    <button mat-stroked-button [disabled]="!hasTemplate(category.formControlName)"
                                        (click)="previewTemplate(category.formControlName)">
                                        <mat-icon>visibility</mat-icon>
                                        Visualizar
                                    </button>

                                    <button mat-stroked-button [disabled]="!hasTemplate(category.formControlName)"
                                        (click)="downloadTemplate(category.formControlName)">
                                        <mat-icon>download</mat-icon>
                                        Baixar
                                    </button>
                                </div>

                                <!-- Informações do Template (Substitui o antigo preview container) -->
                                <div class="template-info-section">
                                    <h4>Status do Template Atual</h4>
                                    <div class="template-info-details"
                                        *ngIf="hasTemplate(category.formControlName) || selectedFiles[category.formControlName]">
                                        <div class="template-info-row">
                                            <span class="info-label">Nome:</span>
                                            <span class="info-value">{{ getTemplateName(category.formControlName)
                                                }}</span>
                                        </div>
                                        <div class="template-info-row"
                                            *ngIf="getTemplateFileType(category.formControlName)">
                                            <span class="info-label">Tipo:</span>
                                            <span class="info-value">{{ getTemplateFileType(category.formControlName)
                                                }}</span>
                                        </div>
                                        <div class="template-info-row" *ngIf="!selectedFiles[category.formControlName]">
                                            <span class="info-label">Estado:</span>
                                            <span class="info-value template-configured">Configurado</span>
                                        </div>
                                        <div class="template-info-row" *ngIf="selectedFiles[category.formControlName]">
                                            <span class="info-label">Estado:</span>
                                            <span class="info-value template-pending">Pendente (Salvar para
                                                aplicar)</span>
                                        </div>
                                    </div>

                                    <div class="template-empty-state"
                                        *ngIf="!hasTemplate(category.formControlName) && !selectedFiles[category.formControlName]">
                                        <mat-icon>info_outline</mat-icon>
                                        <p>Nenhum template configurado para {{ category.title }}.</p>
                                        <p>Carregue um arquivo HTML ou DOCX.</p>
                                    </div>
                                </div>

                                <!-- Campo oculto -->
                                <div class="hidden-field">
                                    <textarea [formControlName]="category.formControlName" hidden></textarea>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </ng-container>
                </div>

                <!-- Dicas e variáveis -->
                <div class="template-tips">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <mat-icon>lightbulb</mat-icon>
                                <span>Variáveis disponíveis para
                                    templates</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="variables-container">
                            <p class="variables-intro">Ao editar um template,
                                você pode usar estas variáveis que serão
                                substituídas pelos dados reais no contrato:</p>

                            <div class="variables-grid">
                                <div class="variable-category">
                                    <h4>Dados do Parceiro</h4>
                                    <div class="variable-item">
                                        <code>{{ '{' }}nome_parceiro{{ '}'
                                            }}</code>
                                        <span>Nome do parceiro</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}documento_parceiro{{ '}'
                                            }}</code>
                                        <span>CNPJ/CPF</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}email_parceiro{{ '}'
                                            }}</code>
                                        <span>Email</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}telefone_parceiro{{ '}'
                                            }}</code>
                                        <span>Telefone</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}endereco_parceiro{{ '}'
                                            }}</code>
                                        <span>Endereço</span>
                                    </div>
                                </div>

                                <div class="variable-category">
                                    <h4>Dados do Sistema</h4>
                                    <div class="variable-item">
                                        <code>{{ '{' }}sistema_parceiro{{ '}'
                                            }}</code>
                                        <span>Nome do sistema</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}tipo_sistema{{ '}'
                                            }}</code>
                                        <span>Tipo do sistema</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}email_sistema{{ '}'
                                            }}</code>
                                        <span>Email do sistema</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}descricao_sistema{{ '}'
                                            }}</code>
                                        <span>Descrição</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}vencimento_sistema{{ '}'
                                            }}</code>
                                        <span>Vencimento</span>
                                    </div>
                                </div>

                                <div class="variable-category">
                                    <h4>Datas do Contrato</h4>
                                    <div class="variable-item">
                                        <code>{{ '{' }}data_inicio{{ '}'
                                            }}</code>
                                        <span>Data de início</span>
                                    </div>
                                    <div class="variable-item">
                                        <code>{{ '{' }}data_termino{{ '}'
                                            }}</code>
                                        <span>Data de término</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </mat-dialog-content>

        <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="8px" class="dialog-footer">
            <button class="save-button" mat-raised-button (click)="onSave()" [disabled]="loading">
                <mat-icon *ngIf="loading" class="loading-icon">hourglass_empty</mat-icon>
                <span>{{ loading ? 'Salvando...' : 'Salvar Templates'
                    }}</span>
            </button>
        </div>
    </form>
</div>